/* istanbul ignore file */

const TOP_AREA_CAP_ROOT_ID = 'online-top-area-root';
const getTopAreaDataConfigAttribute = () => {
  const element = document.getElementById(TOP_AREA_CAP_ROOT_ID);
  if (!element) {
    return undefined;
  }
  return element.dataset.config;
};
async function init() {
  // Personal menu is special as it is rendered in the burger menu of top-area and sidebar on the mypages
  // Root element is created anew and later it is duplicated with the createPortal React function
  const rootElement = document.createElement('div');
  const dataConfigAttribute = getTopAreaDataConfigAttribute();
  rootElement.setAttribute('hidden', 'true');
  rootElement.setAttribute('id', 'personal-menu-hidden');

  // Copy top-area config attribute
  if (dataConfigAttribute) {
    rootElement.dataset.config = dataConfigAttribute;
  }
  document.body.append(rootElement);
  const appRender = await import('./appRender');
  void appRender.render(rootElement);
}
init().catch(error => {
  throw error;
});